export function getArrayFromEnum<T>(enumObject: any) {
    return Object.values(enumObject).filter((v) => isNaN(Number(v))) as T[];
}
